module.exports = __webpack_public_path__ + "99aaf203bc862b1ce2e47aef169e6bf6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-116@2x.png
// module id = 498
// module chunks = 0